export const ACCOUNT_LOCKED_ERROR_CODE = 'ACCOUNT_LOCKED'

type GraphQLErrorExtension = {
  code?: string
  retryAfterSeconds?: number
  attemptsRemaining?: number
}

type GraphQLErrorLike = {
  extensions?: GraphQLErrorExtension
}

type ApolloErrorLike = {
  graphQLErrors?: GraphQLErrorLike[]
}

export const getRetryAfterSecondsFromAuthError = (
  error: ApolloErrorLike
): number => {
  const extension = error?.graphQLErrors?.[0]?.extensions
  if (!extension || extension.code !== ACCOUNT_LOCKED_ERROR_CODE) return 0

  const retryAfterSeconds = Number(extension.retryAfterSeconds || 0)
  if (!Number.isFinite(retryAfterSeconds) || retryAfterSeconds <= 0) return 0

  return Math.ceil(retryAfterSeconds)
}

export const formatRetryCountdown = (seconds: number): string => {
  const safeSeconds = Math.max(0, Math.floor(seconds))
  const minutes = Math.floor(safeSeconds / 60)
  const remainingSeconds = safeSeconds % 60

  return `${String(minutes).padStart(2, '0')}:${String(
    remainingSeconds
  ).padStart(2, '0')}`
}

export const getAttemptsRemainingFromAuthError = (
  error: ApolloErrorLike
): number => {
  const extension = error?.graphQLErrors?.[0]?.extensions
  if (!extension) return -1

  const attemptsRemaining = Number(extension.attemptsRemaining)
  if (!Number.isFinite(attemptsRemaining) || attemptsRemaining < 0) return -1

  return Math.floor(attemptsRemaining)
}
